export default {
  MARK_AS_UNREAD: 0, // 标为未读
  MARK_AS_READ: 1, // 标为已读
  TOP: 2, // 置顶
  UNSTICK: 3, // 取消置顶
  DELETE: 4 // 删除
}
